import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useVentureId } from '~/functions/accounts';
import { EnumIroStatus, EnumIroType, useGetAccountQuery, useUpdateAccountMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'impacts',
  setup: function setup(__props) {
    var _account$value, _account$value2, _account$value3, _account$value4, _account$value5, _account$value6;
    var dataTableIro = ref(null);
    onMounted(function () {
      var _dataTableIro$value, _dataTableIro$value$r;
      dataTableIro === null || dataTableIro === void 0 ? void 0 : (_dataTableIro$value = dataTableIro.value) === null || _dataTableIro$value === void 0 ? void 0 : (_dataTableIro$value$r = _dataTableIro$value.refetch) === null || _dataTableIro$value$r === void 0 ? void 0 : _dataTableIro$value$r.call(_dataTableIro$value);
    });
    var seriesNegative = ref([{
      name: '',
      data: [[-1, 0]] // FIXME: we are creating a "invisible" data point to force to the annotations, without this point, the annotations are not shown.
    }]);
    var seriesPositive = ref([{
      name: '',
      data: [[-1, 0]] // FIXME: we are creating a "invisible" data point to force to the annotations, without this point, the annotations are not shown.
    }]);
    var onResult = function onResult(_ref) {
      var _data$listIros, _data$listIros3;
      var data = _ref.data;
      if (data !== null && data !== void 0 && (_data$listIros = data.listIros) !== null && _data$listIros !== void 0 && _data$listIros.filter(function (iro) {
        return iro.type === EnumIroType.NegativeImpact;
      }).length) {
        var _data$listIros2;
        seriesNegative.value = [{
          name: 'Negative Impact',
          data: (data === null || data === void 0 ? void 0 : (_data$listIros2 = data.listIros) === null || _data$listIros2 === void 0 ? void 0 : _data$listIros2.filter(function (iro) {
            return iro.type === EnumIroType.NegativeImpact;
          }).map(function (x) {
            return [x.likelihood || 3, x.finalSeverity || 8, x.name];
          })) || []
        }];
      }
      if (data !== null && data !== void 0 && (_data$listIros3 = data.listIros) !== null && _data$listIros3 !== void 0 && _data$listIros3.filter(function (iro) {
        return iro.type === EnumIroType.PositiveImpact;
      }).length) {
        var _data$listIros4;
        seriesPositive.value = [{
          name: 'Positive Impact',
          data: (data === null || data === void 0 ? void 0 : (_data$listIros4 = data.listIros) === null || _data$listIros4 === void 0 ? void 0 : _data$listIros4.filter(function (iro) {
            return iro.type === EnumIroType.PositiveImpact;
          }).map(function (x) {
            return [x.likelihood || 3, (x.scale + x.scope) / 2 || 6,
            // average scale and scope
            x.name];
          })) || []
        }];
      }
    };
    var route = useRoute();
    var statusFilter = computed(function () {
      var _route$query = route.query,
        iroStatus = _route$query.iroStatus,
        materialFilter = _route$query.materialFilter;
      if (iroStatus === 'assessed') {
        switch (materialFilter) {
          case 'material':
            return [EnumIroStatus.Material];
          case 'notMaterial':
            return [EnumIroStatus.NotMaterial];
          default:
            return [EnumIroStatus.Material, EnumIroStatus.NotMaterial];
        }
      }
      if (iroStatus === 'notAssessed') {
        return [EnumIroStatus.NotAssessed];
      }
      return [];
    });
    var showNegativePanel = ref(false);
    var showPositivePanel = ref(false);
    var ventureId = useVentureId();
    var _useUpdateAccountMuta = useUpdateAccountMutation({}),
      updateAccount = _useUpdateAccountMuta.mutate,
      loading = _useUpdateAccountMuta.loading;
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureId === null || ventureId === void 0 ? void 0 : ventureId.value
      }),
      result = _useGetAccountQuery.result,
      onAccountResult = _useGetAccountQuery.onResult;

    // TODO: this part can be re-factor to one component of 2 instances
    // But the product seems to be still changing so in order to be changed easily

    var account = computed(function () {
      var _result$value;
      return result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount;
    });
    var csrdNImpactLikelihoodThreshold = ref(account === null || account === void 0 ? void 0 : (_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.csrdNImpactLikelihoodThreshold);
    var csrdNImpactSeverityThreshold = ref(account === null || account === void 0 ? void 0 : (_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.csrdNImpactSeverityThreshold);
    var csrdNImpactThresholdReason = ref(account === null || account === void 0 ? void 0 : (_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.csrdNImpactThresholdReason);
    onAccountResult(function (_ref2) {
      var _data$getAccount, _data$getAccount2, _data$getAccount3, _data$getAccount4, _data$getAccount5, _data$getAccount6;
      var data = _ref2.data;
      if (!(data !== null && data !== void 0 && data.getAccount)) {
        return;
      }
      csrdNImpactLikelihoodThreshold.value = (_data$getAccount = data.getAccount) === null || _data$getAccount === void 0 ? void 0 : _data$getAccount.csrdNImpactLikelihoodThreshold;
      csrdNImpactSeverityThreshold.value = (_data$getAccount2 = data.getAccount) === null || _data$getAccount2 === void 0 ? void 0 : _data$getAccount2.csrdNImpactSeverityThreshold;
      csrdNImpactThresholdReason.value = (_data$getAccount3 = data.getAccount) === null || _data$getAccount3 === void 0 ? void 0 : _data$getAccount3.csrdNImpactThresholdReason;

      // positive
      csrdPImpactLikelihoodThreshold.value = (_data$getAccount4 = data.getAccount) === null || _data$getAccount4 === void 0 ? void 0 : _data$getAccount4.csrdPImpactLikelihoodThreshold;
      csrdPImpactScopeThreshold.value = (_data$getAccount5 = data.getAccount) === null || _data$getAccount5 === void 0 ? void 0 : _data$getAccount5.csrdPImpactScopeThreshold;
      csrdPImpactThresholdReason.value = (_data$getAccount6 = data.getAccount) === null || _data$getAccount6 === void 0 ? void 0 : _data$getAccount6.csrdPImpactThresholdReason;
    });

    // positive
    var csrdPImpactLikelihoodThreshold = ref(account === null || account === void 0 ? void 0 : (_account$value4 = account.value) === null || _account$value4 === void 0 ? void 0 : _account$value4.csrdPImpactLikelihoodThreshold);
    var csrdPImpactScopeThreshold = ref(account === null || account === void 0 ? void 0 : (_account$value5 = account.value) === null || _account$value5 === void 0 ? void 0 : _account$value5.csrdPImpactScopeThreshold);
    var csrdPImpactThresholdReason = ref(account === null || account === void 0 ? void 0 : (_account$value6 = account.value) === null || _account$value6 === void 0 ? void 0 : _account$value6.csrdPImpactThresholdReason);
    return {
      __sfc: true,
      dataTableIro: dataTableIro,
      seriesNegative: seriesNegative,
      seriesPositive: seriesPositive,
      onResult: onResult,
      route: route,
      statusFilter: statusFilter,
      showNegativePanel: showNegativePanel,
      showPositivePanel: showPositivePanel,
      ventureId: ventureId,
      updateAccount: updateAccount,
      loading: loading,
      result: result,
      onAccountResult: onAccountResult,
      account: account,
      csrdNImpactLikelihoodThreshold: csrdNImpactLikelihoodThreshold,
      csrdNImpactSeverityThreshold: csrdNImpactSeverityThreshold,
      csrdNImpactThresholdReason: csrdNImpactThresholdReason,
      csrdPImpactLikelihoodThreshold: csrdPImpactLikelihoodThreshold,
      csrdPImpactScopeThreshold: csrdPImpactScopeThreshold,
      csrdPImpactThresholdReason: csrdPImpactThresholdReason,
      EnumIroType: EnumIroType
    };
  }
});